import React from 'react'
import { Table } from 'react-bootstrap'

const BusinessBeneficiaries = (props) => {
  const { data, viewTxDetails } = props

  return (
    <div className='ibox float-e-margins shadow animated fadeIn'>
      <div className='ibox-title round-corner-box-top'>
        <h5>UBO&rsquo;s & Signatories</h5>
      </div>
      <div className='ibox-content round-corner-box-bottom'>
        {data && data.length ? (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>DOB</th>
                <th>Address</th>
                <th>Social Security Number</th>
                <th>Passport Number</th>
              </tr>
            </thead>
            <tbody>
              {data.map((identity, i) => {
                let address = 'N/A'
                if (identity.identity_addresses.length) {
                  const addressData = identity.identity_addresses[0] || {}
                  let unit = ''
                  if (addressData.unit) {
                    unit = 'Unit ' + addressData.unit + ' '
                  }
                  address =
                    addressData.address +
                    ' ' +
                    unit +
                    addressData.city +
                    ' ' +
                    addressData.state +
                    ' ' +
                    addressData.postalcode
                }
                return (
                  <tr onClick={() => viewTxDetails(identity.transaction)} style={{ cursor: 'pointer' }} key={i}>
                    <td>{identity.first_name + ' ' + identity.last_name}</td>
                    <td>{identity.birth_date}</td>
                    <td>{address}</td>
                    <td>{identity.ssn || 'N/A'}</td>
                    <td>{identity.passport_number || 'N/A'}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        ) : (
          <span>{'N/A'}</span>
        )}
      </div>
    </div>
  )
}

export default BusinessBeneficiaries
